import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import { useLabels } from 'wsm-common-data';
import timeAgo from '../utils/timeAgo';

export const ReviewDateComponent = ({ reviewDate, fontSize = '' }) => {
	const labels = useLabels();
	return (
		<div className={setClassNames(['date', fontSize])}>
			{timeAgo(new Date(reviewDate), labels)}
		</div>
	);
};

ReviewDateComponent.propTypes = {
	reviewDate: PropTypes.string.isRequired,
	fontSize: PropTypes.string
};

export default ReviewDateComponent;
